// extracted by mini-css-extract-plugin
export var assigneeBadge = "_mc-0";
export var assigneeDetails = "_mc-1";
export var assigneeInfo = "_mc-2";
export var dropdownContainer = "_mc-4";
export var dropdownImage = "_mc-5";
export var editAssigneeInfo = "_mc-3";
export var editAssigneeModalContainer = "_mc-6";
export var hidden = "_mc-8";
export var input = "_mc-7";